import { render, staticRenderFns } from "./CaseTabs.vue?vue&type=template&id=9d08111c&scoped=true"
import script from "./CaseTabs.vue?vue&type=script&lang=js"
export * from "./CaseTabs.vue?vue&type=script&lang=js"
import style0 from "./CaseTabs.vue?vue&type=style&index=0&id=9d08111c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d08111c",
  null
  
)

export default component.exports